import { useCallback } from 'react';
import { createSignal } from '@funtech-int/rival';

import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';
import { useOnPlaybackRateChange } from '@/scenarios/legacy-player/hooks/useOnPlaybackRateChange';
import { useOnReady } from '@/scenarios/legacy-player/hooks/useOnReady';

const playbackRate = createSignal<number | null>(null);

export const usePlaybackRateWatcher = () => {
    const onPlaybackRateChange = useCallback((playerPlaybackRate?: number) => {
        if (playerPlaybackRate) {
            playbackRate.set(playerPlaybackRate);
        }
    }, []);

    const onReady = useInstanceCallback((instance) => {
        const playbackRateSavedValue = playbackRate.get();
        if (playbackRateSavedValue) {
            instance?.setPlaybackRate(playbackRateSavedValue);
        }
    }, []);

    useOnPlaybackRateChange(onPlaybackRateChange);
    useOnReady(onReady);
};
